import { render, staticRenderFns } from "./group-selector-item.vue?vue&type=template&id=e15943c4"
import script from "./group-selector-item.vue?vue&type=script&lang=js"
export * from "./group-selector-item.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports